import { Trans, useTranslation } from 'next-i18next';

import { pathFor } from '../../../helpers/links';
import { useHubspotChat } from '../../../hooks/useHubspotChat';
import { TrackLinkClicked } from '../../../utils/analytics';
import UnderlinedLink from '../../UnderlinedLink';

type Props = {
  orderAndShippingHelp?: boolean;
  analytics: Analytics;
  onClose: () => void;
};

export const ProductHelp: React.FC<Props> = (props) => {
  const { analytics, onClose, orderAndShippingHelp } = props;
  const { t } = useTranslation('product');
  const { openHandler } = useHubspotChat();
  const translationKey = orderAndShippingHelp
    ? 'helpWithOrdersAndShipping'
    : 'help';

  return (
    <div className="text-neutral-4">
      <Trans i18nKey={translationKey} t={t}>
        Got questions about buying art? See&nbsp;
        <UnderlinedLink
          href={pathFor({ page: 'SUPPORT', slug: 'shipping' })}
          onClick={() => {
            TrackLinkClicked({
              title: 'Visit support',
              page: analytics.page,
              context: `${analytics.context} support`.trim(),
              url: pathFor({ page: 'SUPPORT', slug: 'shipping' }),
              isExternal: false,
            });
          }}
          target="_blank"
        >
          Support
        </UnderlinedLink>
        &nbsp;or&nbsp;
        <button
          className="hyperlink"
          onClick={() => {
            openHandler();
            onClose();
          }}
          type="button"
        >
          chat with us
        </button>
      </Trans>
    </div>
  );
};
